module.exports = __webpack_public_path__ + "static/CloudBattery-2-dark-e77308f300994604e8fc4484277edab9.svg";